import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const PING_INTERVAL = 4 * 60 * 1000; // 4 minutes

let keepAliveInterval = null;

/**
 * Keep-alive service to prevent backend from going idle
 * Pings the backend every 4 minutes
 */
export const startKeepAlive = () => {
  // Clear any existing interval
  if (keepAliveInterval) {
    clearInterval(keepAliveInterval);
  }

  // Initial ping
  pingBackend();

  // Set up recurring pings
  keepAliveInterval = setInterval(() => {
    pingBackend();
  }, PING_INTERVAL);

  console.log('[KeepAlive] Service started - pinging every 4 minutes');
};

export const stopKeepAlive = () => {
  if (keepAliveInterval) {
    clearInterval(keepAliveInterval);
    keepAliveInterval = null;
    console.log('[KeepAlive] Service stopped');
  }
};

const pingBackend = async () => {
  try {
    await axios.get(`${API_URL}/api/health/ping`, { timeout: 5000 });
    console.log('[KeepAlive] Ping successful');
  } catch (error) {
    // Silently fail - don't disrupt user experience
    console.warn('[KeepAlive] Ping failed:', error.message);
  }
};

export default { startKeepAlive, stopKeepAlive };
